<template>
    <div class="toast scroll-behavior" :class="[`${type}`, `${indent}`]" @click="close_alert">
        <div class="d-flex d-flex justify-content-center">
            <div class="toast-body align-items-center hstack">
                <span class="material-symbols-outlined pe-2 text-white-50 pb-1" style="font-size: 30px;">{{ getType() }}</span>
                <div class="t-message" v-html="message"></div>
            </div>
            <button type="button" class="btn-close"></button>
        </div>
    </div>
</template>

<script>

/*
    TYPE
    red - красный
    yellow - желтый
    green - зелёный
    gray - серый
*/

/*
    ICONS
    red - warning
    yellow -
    green -
    gray -
*/

export default {
    name: "ToastAlert",
    props: {
        message: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: ''
        },
        indent: {
            type: String,
            default: ''
        }
    },
    computed: {

    },
    methods: {
        close_alert(){
            this.$emit('close_alert')
        },
        getType() {
          if(this.type == 'green') {
            return 'check_circle'
          } else if(this.type == 'yellow') {
            return 'warning'
          } else if(this.type == 'red') {
            return 'error'
          } else if(!this.type) {
            return 'info'
          }

        }
    }
}
</script>

<style lang="scss" scoped>
.toast:not(.show) {
    display: block;
}
.indent {
    bottom:0px !important;
}
.toast {
    position: fixed;
    bottom: 0px;
    width: 100%;
    color: #fff;
    z-index: 100000;
    background-color: #384357;
    border: none;
    border-radius: 0;
    .toast-body {
        padding: 20px 40px 50px 40px;
        font-size: 0.9rem;
        font-weight: 400;
        text-align: center;
        max-width: 500px;
        .t-message {
            text-align: start;
        }
    }
    .btn-close {
        position: absolute;
        right: 10px;
        top: 10px;
        margin: 0 !important;
        padding: 5px;
        font-size: 15px;
        //background-color: #fff;

    }
    &.red {
        background-color: #a40000;
    }
    &.green {
        background-color: #005c2b;
    }
    &.yellow {
        background-color: #e8d500;
        color: #333;
    }
}
.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 1, 1, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(60px);
  /* opacity: 0; */
}
</style>
